import { createTheme } from '@material-ui/core/styles';
import { CSSProperties } from 'react';
import { CustomColorsInterface } from 'config/themes/types';

const CustomColors: CustomColorsInterface = {
  main: '#6d5afc',
  orange: '#F9C106',
  lightGray: '#EBEBEB',
  gray: '#ABAFB5',
  darkGray: '#979797',
  green: '#59BA49',
};

const allButtonStyles: CSSProperties = {
  padding: '15px 40px',
  boxShadow: 'none',
  fontSize: 16,
  borderRadius: 10,
  textTransform: 'none',
};

const ledTheme = createTheme({
  spacing: 5,
  palette: {
    type: 'light',
    customColors: CustomColors,
    gradients: {},
    primary: {
      main: '#FFA700',
    },
    secondary: {
      main: '#6C5AFC',
    },
    text: {
      primary: '#8E8E8E',
      secondary: '#182341',
    },
    common: {
      black: '#000',
      white: '#FFF',
    },
    info: {
      main: '#99C3BB',
    },
    error: {
      main: '#DB4957',
    },
    background: {
      default: '#F9F9F9',
      paper: '#FFF',
    },
  },
  typography: {
    fontFamily: ['Mulish', 'sans-serif'].join(','),
    h2: {
      color: '#182341',
      fontWeight: 700,
      fontSize: 32,
      '@media(min-width: 375px)': {
        fontSize: 36,
      },
    },
    h3: {
      color: '#182341',
      fontWeight: 700,
      fontSize: 18,
      '@media(min-width: 600px)': {
        fontSize: 21,
      },
      '@media(min-width: 960px)': {
        fontSize: 24,
      },
    },
    h4: {
      color: '#000',
      fontWeight: 700,
      fontSize: 24,
    },
    h5: {
      color: '#000',
      fontWeight: 700,
      fontSize: 18,
    },
    body1: {
      fontWeight: 400,
      fontSize: 16,
      '@media(min-width: 600px)': {
        fontSize: 18,
      },
    },
    body2: {
      fontWeight: 400,
      fontSize: 16,
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          '@media(min-width: 1279px)': {
            overflow: 'hidden',
          },
          '@media(max-width: 1279px)': {
            overflow: 'auto',
          },
        },
      },
    },
    MuiCheckbox: {},
    MuiButton: {
      contained: { ...allButtonStyles },
      outlined: { ...allButtonStyles },
      text: {
        ...allButtonStyles,
        fontWeight: 600,
        color: '#182341',
        padding: '15px 20px',
        '&$disabled': {
          backgroundColor: 'transparent',
          color: '#8E8E8E',
        },
      },
      textPrimary: {
        background: 'rgba(255, 167, 0, 0.15)',
        '&:hover': {
          backgroundColor: '#FFA700',
          color: '#FFF',
        },
      },
      textSecondary: {
        backgroundColor: '#F9F9F9',
        color: '#182341',
        '&:hover': {
          backgroundColor: '#F9F9F9',
        },
      },
      containedPrimary: {
        color: 'white',
        fontWeight: 700,
        '&:hover': {
          backgroundColor: '#E89700',
          boxShadow: 'none',
        },
        '&$disabled': {
          backgroundColor: '#8E8E8E',
          color: '#FFF',
        },
      },
      containedSecondary: {
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: '#6C5AFC',
        },
      },
      outlinedSecondary: {
        backgroundColor: 'rgba(108, 90, 252, 0.2)',
        border: '1px solid #6C5AFC',
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: '#6C5AFC',
          color: '#FFF',
        },
      },
    },
  },
});
export default ledTheme;
